<template>
  <div class="h-182 pt-60 pb-60 bg-green-deep mb-60">
    <h1 class='banner-title fw-700 fs-32 mb-fs-28 tc cream'>
      {{title}}
    </h1>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  props:{
    title:{
      type: String,
      default: ''
    },

  },
}
</script>

<style lang="scss" scoped>
.banner-title {
  letter-spacing: -0.04em; // v2 display tracking (§Typography Scale L94–96)
}
</style>
